/**
 * Consistent French date formatting helpers.
 * Style: dd/mm/yyyy (slash-separated) per French standard.
 */

const pad = (n) => String(n).padStart(2, '0');

/** Format any date-like (Date, ISO, yyyy-mm-dd string) as dd/mm/yyyy. Returns '' if invalid. */
export const fmtDateFR = (input) => {
  if (!input) return '';
  try {
    let d;
    if (input instanceof Date) d = input;
    else if (typeof input === 'string') {
      // Pure YYYY-MM-DD: parse as local date to avoid TZ shifting
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(input.trim());
      if (m) return `${m[3]}/${m[2]}/${m[1]}`;
      d = new Date(input);
    } else {
      d = new Date(input);
    }
    if (isNaN(d.getTime())) return '';
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
  } catch { return ''; }
};

/** Date + heure: dd/mm/yyyy HH:mm */
export const fmtDateTimeFR = (input) => {
  if (!input) return '';
  try {
    const d = input instanceof Date ? input : new Date(input);
    if (isNaN(d.getTime())) return '';
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  } catch { return ''; }
};

/** Full with seconds: dd/mm/yyyy HH:mm:ss */
export const fmtDateTimeSecFR = (input) => {
  if (!input) return '';
  try {
    const d = input instanceof Date ? input : new Date(input);
    if (isNaN(d.getTime())) return '';
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  } catch { return ''; }
};
